import { getSalonAdminApiBaseUrl } from "../../salon-admin/utils/apiConfig";
import { hqSessionFetchInit } from "../hqSessionAuth";

function adminBase() {
  return (getSalonAdminApiBaseUrl() || "").replace(/\/$/, "");
}

function hasPortalSession(portalId) {
  return Boolean(localStorage.getItem(`naturals_${portalId}_userId`));
}

async function salonAdminGet(portalId, path, query = {}) {
  const base = adminBase();
  if (!base || !hasPortalSession(portalId)) {
    throw new Error("Not authenticated");
  }
  const qs = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") qs.set(key, String(value));
  });
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  const res = await fetch(`${base}${path}${suffix}`, hqSessionFetchInit(portalId));
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    throw new Error(data?.error || "Request failed");
  }
  return data;
}

/** @param {'partner'|'workspace'|'executive'} portalId */
export function createSalonAdminAnalyticsClient(portalId) {
  return {
    async fetchFlowAnalytics({ fromDate, toDate, flowType = "all", stylistId = "all", franchiseId } = {}) {
      const data = await salonAdminGet(portalId, "/partner/flow-analytics", {
        fromDate,
        toDate,
        flowType,
        stylistId,
        franchiseId,
      });
      return data.analytics || {};
    },
    async fetchServiceAnalytics({ fromDate, toDate, franchiseId } = {}) {
      const data = await salonAdminGet(portalId, "/partner/service-analytics", {
        fromDate,
        toDate,
        franchiseId,
      });
      return data.analytics || {};
    },
    async fetchStaffAnalytics({ fromDate, toDate, franchiseId } = {}) {
      const data = await salonAdminGet(portalId, "/partner/staff-analytics", {
        fromDate,
        toDate,
        franchiseId,
      });
      return data.analytics || {};
    },
    async fetchCustomerAnalytics({ fromDate, toDate, franchiseId } = {}) {
      if (portalId === "workspace" || portalId === "executive") {
        const data = await salonAdminGet(portalId, "/nyafaz-ep/customers/analytics", {
          fromDate,
          toDate,
          franchiseId,
        });
        return data.analytics || {};
      }
      const data = await salonAdminGet(portalId, "/partner/customers/analytics", {
        fromDate,
        toDate,
      });
      return data.analytics || {};
    },
  };
}
